import apiClient from "../common/apiClient.js";

export default class BankController {
  async Create(data, token) {
    try {
      return await apiClient.post("/tenant/bank", data, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }

  async Update(data, token) {
    try {
      return await apiClient.put("/tenant/bank", data, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }

  async Get(tenantId, token) {
    try {
      return await apiClient.get("/tenant/bank/" + tenantId, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }
}
